import DashboardStepsContainer from './dashboard_steps_container';

const DashboardSteps = DashboardStepsContainer;
export default DashboardSteps;
